import { lazy } from "react";

export const digitlizationRoutes = [
  { path: "/CollectionTarget", component: lazy(() => import("../../Components/Masters/CollectionTarget")) },
  { path: "/PsAssessmentVerify", component: lazy(() => import("../../Components/Taxes/PsAssessmentVerify")) },

  { path: "/AuctionsPsVerify", component: lazy(() => import("../../Components/Non-Taxes/Auctions/AuctionsPsVerify")) },
  { path: "/AuctionsEntryForm", component: lazy(() => import("../../Components/Non-Taxes/Auctions/AuctionsEntryForm")) },

  { path: "/HouseTaxDemandConfirmation", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/HouseTaxDemandConfirmation")) },
  { path: "/TapPsVerify", component: lazy(() => import("../../Components/Non-Taxes/TapFee/TapPsVerify")) },

  { path: "/misAbstracttatusReport", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/MISStatusReport")) },
  { path: "/NontaxDemandpercentage", component: lazy(() => import("../../Components/Non-Taxes/Reports/NontaxDemandpercentage")) },

  { path: "/CollectionTargetHouseTax", component: lazy(() => import("../../Components/Taxes/DCB/CollectionTargetCommonHouseTax")) },
  { path: "/CollectionTargetTap", component: lazy(() => import("../../Components/Taxes/DCB/CollectionTargetTap")) },
  { path: "/CollectionTargetTarde", component: lazy(() => import("../../Components/Taxes/DCB/CollectionTargetTarde")) },

  { path: "/AssesmentPurificationReport", component: lazy(() => import("../../Components/Assesmentpurification/AssesmentPurificationReport")) },
  { path: "/DemandGenerationHouseTaxReport", component: lazy(() => import("../../Components/Assesmentpurification/DemandGenerationHouseTaxReport")) },

  { path: "/NonTaxesStatusreport", component: lazy(() => import("../../Components/Non-Taxes/Reports/NonTaxesStatusreport")) },
  { path: "/statusofnontaxes", component: lazy(() => import("../../Components/Non-Taxes/Reports/StatusOfNonTaxes")) },

  { path: "/OldReceiptCancelation", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/OldReceiptCancelation")) },
  { path: "/ChallanDetailsEntryDPO", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/ChallanDetailsEntryDPO")) },
];
